/* RESPONSIBLE TEAM: team-messenger */

import Model, { attr } from '@ember-data/model';

export default class FinSuffixSettings extends Model {
  @attr() declare appId: string;
  @attr() declare showAiAgentSuffix: boolean;
}
